function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "add-message");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "add-message",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M649.25,282 L92.75,282 C41.5925781,282 0,323.592578 0,374.75 L0,792.125 C0,843.282422 41.5925781,884.875 92.75,884.875 L231.875,884.875 L231.875,1006.60938 C231.875,1016.89883 240.280469,1024 249.265625,1024 C252.74375,1024 256.366797,1022.98555 259.555078,1020.52188 L440.5625,884.875 L649.25,884.875 C700.407422,884.875 742,843.282422 742,792.125 L742,374.75 C742,323.592578 700.407422,282 649.25,282 Z M673,792 C673,804.736842 662.563462,815.157895 649.807692,815.157895 L417.884615,815.157895 L399.330769,829.052632 L301.923077,902 L301.923077,815.157895 L93.1923077,815.157895 C80.4365385,815.157895 70,804.736842 70,792 L70,375.157895 C70,362.421053 80.4365385,352 93.1923077,352 L649.807692,352 C662.563462,352 673,362.421053 673,375.157895 L673,792 Z M534.75,479 L209.25,479 C196.4625,479 186,489.5 186,502.333333 L186,525.666667 C186,538.5 196.4625,549 209.25,549 L534.75,549 C547.5375,549 558,538.5 558,525.666667 L558,502.333333 C558,489.5 547.5375,479 534.75,479 Z M393.8,619 L208.2,619 C195.44,619 185,629.5 185,642.333333 L185,665.666667 C185,678.5 195.44,689 208.2,689 L393.8,689 C406.56,689 417,678.5 417,665.666667 L417,642.333333 C417,629.5 406.56,619 393.8,619 Z",
  id: "Shape",
  fill: "#05CDB3",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M998.428571,140.642857 L883.357143,140.642857 L883.357143,25.5714286 C883.357143,11.4512054 871.905938,0 857.785714,0 L832.214286,0 C818.094062,0 806.642857,11.4512054 806.642857,25.5714286 L806.642857,140.642857 L691.571429,140.642857 C677.451205,140.642857 666,152.094063 666,166.214286 L666,191.785714 C666,205.905938 677.451205,217.357143 691.571429,217.357143 L806.642857,217.357143 L806.642857,332.428571 C806.642857,346.548795 818.094063,358 832.214286,358 L857.785714,358 C871.905938,358 883.357143,346.548795 883.357143,332.428571 L883.357143,217.357143 L998.428571,217.357143 C1012.54879,217.357143 1024,205.905938 1024,191.785714 L1024,166.214286 C1024,152.094062 1012.54879,140.642857 998.428571,140.642857 Z",
  id: "Path",
  fill: "#05CDB3",
  fillRule: "nonzero"
}));

var SvgAddMessage = function SvgAddMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-message.a95143ed.svg";
export { ForwardRef as ReactComponent };